/**
 * 系統（企画書 §9.1）。
 *
 * ID は日本語名のローマ字ではなく、得意傾向を表す英語にしてある。企画書に
 * 「正式名称は別途検討する」とある通り表示名は仮のもので、あとで「剛」が別の名前に
 * なっても ID を変えずに済むようにするため。ID はデータベースに永続化されるので、
 * 表示名の変更で migration が必要になる設計は避ける。
 */
export const ARCHETYPE_IDS = ['power', 'guard', 'swift', 'arcane', 'trickster', 'anomaly'];
/**
 * 系統の定義。
 *
 * 「得意傾向」であって「縛り」ではない。企画書 §9.2 は、守タイプなのに SPD 極振りといった
 * 系統に逆らったビルドが成立することを明示的に重視している。補正の実装
 * (`@drawgon/game-engine`) でも、系統外のステータスにペナルティを与えてはいけない。
 */
export const ARCHETYPES = {
    power: { id: 'power', name: '剛', description: 'ATK が高いほど攻撃補正がかかる' },
    guard: { id: 'guard', name: '守', description: 'DEF が高いほど被ダメージが軽減される' },
    swift: { id: 'swift', name: '速', description: 'SPD 差によって追加行動の確率が上がる' },
    arcane: { id: 'arcane', name: '術', description: '特殊攻撃に補正がかかる' },
    trickster: { id: 'trickster', name: '変', description: '回避と状態異常に補正がかかる' },
    anomaly: { id: 'anomaly', name: '異', description: '特殊能力を持つ' },
};
